'use client';

import { c as _c } from "react/compiler-runtime";
import { DropdownMenu } from '@common/components';
import { SvgArrowdownFill } from '@common/icon';
import { usePathname, useSearchParams } from 'next/navigation';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { DEFAULT_SEARCH_CATEGORY, SEARCH_CATEGORY_GROUPS, SEARCH_CATEGORY_ITEMS, SEARCH_CATEGORY_QUERY_KEY } from './constants';
export function SearchCategoryDropdown() {
  const $ = _c(17);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const {
    replace
  } = useCustomRouter();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(SEARCH_CATEGORY_QUERY_KEY) ?? DEFAULT_SEARCH_CATEGORY;
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentValue = t0;
  let t1;
  if ($[2] !== currentValue) {
    t1 = SEARCH_CATEGORY_ITEMS.find(item => item.value === currentValue)?.label ?? "\uC804\uCCB4";
    $[2] = currentValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const currentLabel = t1;
  let t2;
  if ($[4] !== pathname || $[5] !== replace || $[6] !== searchParams) {
    t2 = value => {
      const params = new URLSearchParams();
      const keyword = searchParams.get("q");
      if (keyword) {
        params.set("q", keyword);
      }
      if (value !== DEFAULT_SEARCH_CATEGORY) {
        params.set(SEARCH_CATEGORY_QUERY_KEY, value);
      }
      const query = params.toString();
      replace(`${pathname}${query ? `?${query}` : ""}`, {
        scroll: false
      });
    };
    $[4] = pathname;
    $[5] = replace;
    $[6] = searchParams;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const handleChange = t2;
  let t3;
  if ($[8] !== currentLabel) {
    t3 = <span className="whitespace-nowrap font-500 text-Gray-900 typo-body3 mobile-tablet:min-w-0 mobile-tablet:truncate mobile-tablet:font-400 mobile-tablet:tracking-[-0.28px] mobile-tablet:text-Gray-700 mobile-tablet:typo-body4">{currentLabel}</span>;
    $[8] = currentLabel;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SvgArrowdownFill className="size-16 shrink-0 text-Gray-900 mobile-tablet:text-Gray-700" />;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3) {
    t5 = <div className="flex min-w-0 items-center gap-4 rounded-pill px-12 py-4 mobile-tablet:px-8">{t3}{t4}</div>;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== currentValue || $[14] !== handleChange || $[15] !== t5) {
    t6 = <DropdownMenu type="custom" className="mobile-tablet:w-auto mobile-tablet:min-w-80 mobile-tablet:max-w-100" groups={SEARCH_CATEGORY_GROUPS} value={currentValue} onChange={handleChange}>{t5}</DropdownMenu>;
    $[13] = currentValue;
    $[14] = handleChange;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}